<template lang="pug">
		
	.toggle-text(:class="{'-toggle-open-': blockHeight !== 0}")
		p.toggle-text__inner(
			:class="textClass"
			ref="text"
			v-html="text"
		)

		.toggle-text__icon-wrapper(
			@click="toggleBlock" 
			title="Показать полностью"
			v-if="isShowArrow"
		)
			Icon.toggle-text__icon(icon="arrow-down")
		
</template>

<script>
export default {
  props: {
    textClass: {},
    text: {}
  },
  data: () => ({
    blockHeight: 0,
    isShowArrow: false
  }),
  watch: {
    text() {
      this.showArrow();
    }
  },
  mounted() {
    this.showArrow();
  },
  methods: {
    showArrow() {
      setTimeout(() => {
        if (!this.$refs.text) {
          return;
        }
        this.isShowArrow =
          this.$refs.text.scrollHeight > this.$refs.text.clientHeight;
      }, 0);
    },
    toggleBlock() {
      if (this.blockHeight === 0) {
        this.blockHeight = this.$refs.text.clientHeight;
        this.$refs.text.style.height = `${this.blockHeight}px`;
        setTimeout(() => {
          this.$refs.text.style.height = `${this.$refs.text.scrollHeight}px`;
        }, 0);
        this.$refs.text.style.maxHeight = 'none';
      } else {
        const duration = +window
          .getComputedStyle(this.$refs.text, null)
          .getPropertyValue('transition-duration')
          .replace('s', '');

        this.$refs.text.style.height = `${this.blockHeight}px`;
        setTimeout(() => {
          this.$refs.text.style.removeProperty('height');
          this.$refs.text.style.removeProperty('max-height');
        }, duration * 1000);
        this.blockHeight = 0;
      }
    }
  }
};
</script>
